import React from 'react';
const TabelGajiPPPK = () => <div><h4>Tabel Gaji PPPK</h4><p>Fitur akan segera hadir.</p></div>;
export default TabelGajiPPPK;